import { useDispatch, useSelector } from 'react-redux';
import { Button, IllustrativeIcon, InlineLink, Surface, Txt } from '@vst/beam';
import { Alert } from '@vst/beam-icons/illustrative-icons';
import { useTranslation } from 'react-i18next';

import { Container } from '@app/components/Container';
import { useScreenResolution } from '@app/hooks';
import { selectConfig, setChangePlanError } from '@app/redux';

import { Platform } from '@mfe/shared/schema-types';

import { NavigationHandlers } from '../../../types';

import styles from './styles.module.scss';

const SubmitError = ({ navigateToOverview }: Pick<NavigationHandlers, 'navigateToOverview'>) => {
  const { t } = useTranslation('ChangePlan');

  const { isExtraSmall, isSmall } = useScreenResolution();
  const isMobile = isExtraSmall || isSmall;
  const dispatch = useDispatch();
  const { platform } = useSelector(selectConfig);
  const hrefLink = `tel:${t('orderError.phoneNumber')}`;

  const goToOverview = () => {
    if (platform === Platform.Web) {
      dispatch(setChangePlanError(null));
    }

    navigateToOverview();
  };

  return (
    <Container>
      <Surface className={styles['container']} radius={isMobile ? '0px' : '16px'} my={{ xs: undefined, sm: '72px' }}>
        <div data-cy="Alert-Icon">
          <IllustrativeIcon name="Alert" icon={Alert} color="alert_400" width={95} height={95} />
        </div>

        <Surface px={{ xs: '16px', sm: '24px', md: '40px' }} mt="48px" mb="40px">
          <Txt data-cy="orderError-title" variant="heading4" mb="12px">
            {t('orderError.title')}
          </Txt>
          <Txt data-cy="orderError-description" variant="bodyLargeRegular" color="subtle">
            {t('orderError.description')}{' '}
            {isMobile ? (
              <InlineLink className={styles['phoneNumber']} href={hrefLink} data-cy="orderError-phoneNumber-mobileView">
                {t('orderError.phoneNumber')}
              </InlineLink>
            ) : (
              <Txt component="span" data-cy="orderError-phoneNumber-desktopView" style={{ fontWeight: 'bold' }}>
                {t('orderError.phoneNumber')}
              </Txt>
            )}
          </Txt>
          <Button
            className={styles['backToMyViasat']}
            data-cy="orderError-button"
            fluid
            onClick={goToOverview}
            mt="40px"
          >
            {t('orderError.button')}
          </Button>
        </Surface>
      </Surface>
    </Container>
  );
};

export default SubmitError;
